import * as firebase from "firebase/app";
import "firebase/messaging";
import "firebase/analytics";

const config = {
  apiKey: "AIzaSyD7Eltri37fc1Ae3xUy4PeT9iZJ1OMeWIw",
  authDomain: "wmrtu-fbe25.firebaseapp.com",
  databaseURL: "https://wmrtu-fbe25.firebaseio.com",
  projectId: "wmrtu-fbe25",
  storageBucket: "wmrtu-fbe25.appspot.com",
  messagingSenderId: "852504493911",
  appId: "1:852504493911:web:b0c528cd2c8c6c7b5dc812",
  measurementId: "G-SY56R1W1HK",
};

firebase.initializeApp(config);
firebase.analytics();
export default firebase;
